var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDotTm = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8248_71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#00BCDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7229 39.5V37.4317H34V37H35.988V37.4317H35.2651V39.5H34.7229Z",
    fill: "#00BCDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4699 39.5V37H37.1124L37.8454 38.506L38.5683 37H39.2108V39.5H38.6787V37.9036L38.0663 39.1486H37.6345L37.012 37.9036V39.5H36.4699Z",
    fill: "#00BCDA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8248_71"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDotTm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Dot_TM.b1f2ad9b83d6300f5026e55e2af515ad.svg";